import { Link } from "react-router";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { Button, InputField } from "@hatch-digital-nl/abs-storybook/legacy";
import searchImage from "../../../common/images/search.svg";
import { useAppDispatch } from "../../../app/hooks";
import { debounce } from "../../../common/utils/debounce";
import { JSX } from "react";
import { setCurrentPage, setSearchTerm } from "../ScheduledQualificationsSlice";
import { setIsScheduleQualificationModalOpen } from "../../../modals/UpsertScheduleQualificationModal/UpsertScheduleQualificationModalSlice";

export const ScheduledQualificationsHeader = (): JSX.Element | null => {
    const dispatch = useAppDispatch();

    return (
        <div className="p-scheduled-qualifications__header">
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /{" "}
                    <Link to={RouteEnum.QUALIFICATIONS}>Kwalificaties</Link> /{" "}
                    <Link to={RouteEnum.SCHEDULED_QUALIFICATIONS}>
                        Ingeplande kwalificaties
                    </Link>
                </span>
            </div>
            <div className="c-header-search">
                <div className="c-header-search__title">
                    <h2>Ingeplande Kwalificaties</h2>
                </div>
                <div className="c-header-search__search c-header-search__search--button">
                    <Button
                        onClick={() =>
                            dispatch(setIsScheduleQualificationModalOpen(true))
                        }
                        variant={"primary"}
                    >
                        + Toevoegen
                    </Button>
                    <InputField
                        placeHolder={"Zoeken..."}
                        iconRight={searchImage}
                        onChange={debounce((value: string) => {
                            dispatch(setSearchTerm(value));
                            dispatch(setCurrentPage(1));
                        })}
                    />
                </div>
            </div>
        </div>
    );
};
